var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 2.50065H15.8337V1.66732C15.8337 1.20708 15.4606 0.833984 15.0003 0.833984V0.833984C14.5401 0.833984 14.167 1.20708 14.167 1.66732V2.50065H5.83366V1.66732C5.83366 1.20708 5.46056 0.833984 5.00033 0.833984V0.833984C4.54009 0.833984 4.16699 1.20708 4.16699 1.66732V2.50065H3.33366C2.41699 2.50065 1.66699 3.25065 1.66699 4.16732V16.6673C1.66699 17.584 2.41699 18.334 3.33366 18.334H16.667C17.5837 18.334 18.3337 17.584 18.3337 16.6673V4.16732C18.3337 3.25065 17.5837 2.50065 16.667 2.50065ZM16.667 16.6673H3.33366V6.66732H16.667V16.6673Z",
    fill: "#757575"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.83398,
    y: 8.33398,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    fill: "#757575"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.83398,
    y: 10.834,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    fill: "#757575"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.83398,
    y: 13.334,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    fill: "#757575"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.16699,
    y: 8.33398,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    fill: "#757575"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.16699,
    y: 10.834,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    fill: "#757575"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.16699,
    y: 13.334,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    fill: "#757575"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8.33398,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    fill: "#757575"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 10.834,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    fill: "#757575"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1e781aa7.svg";
export { ForwardRef as ReactComponent };